<template>
  <div
    :class="{
      forgot: true,
      loginFootball: getBackgroundClass === 'loginFootball',
      loginBaseball: getBackgroundClass === 'loginBaseball',
      loginBasketball: getBackgroundClass === 'loginBasketball',
      loginSoccer: getBackgroundClass === 'loginSoccer',
    }"
  >
    <MemberForgotPasswordComponent />
  </div>
</template>
<script>
import MemberForgotPasswordComponent from "../components/MemberForgotPasswordComponent.vue";
export default {
  components: {
    MemberForgotPasswordComponent,
  },
  computed: {
    getBackgroundClass() {
      const classes = [
        "loginFootball",
        "loginBaseball",
        "loginBasketball",
        "loginSoccer",
      ];
      return classes[Math.floor(Math.random() * classes.length)];
    },
  },
};
</script>
